// extracted by mini-css-extract-plugin
module.exports = {"streaming":"live-streaming_streaming__3B-5H","stream-player":"live-streaming_stream-player__18Prm"};